module.exports = __webpack_public_path__ + "static/img/08zhongshu.8b426500.gif";